import React from 'react';
import WithPaper from 'common/hocs/WithPaper';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Icon from 'common/components/Icon';
import { FormPanelType } from '../../../common/constants';
import { makeFormPanelStyles } from 'styles/pages/checkout';
import { DEFAULT_GRID_CONTAINER_SPACING } from 'common/constants';
import InvoiceData from './InvoiceData';
import PaymentType from './PaymentType';
import RecipientData from './RecipientData';
import ShipmentData from './ShipmentData';
import ShippingForm from './ShippingForm';
import RealizationDate from './RealizationDate';
import { CustomerEmail, Notes } from '../components/Promoter';
import { Hidden } from '@material-ui/core';

type Props = {
    type:
    | FormPanelType.invoiceData
    | FormPanelType.payment
    | FormPanelType.recipientData
    | FormPanelType.shipmentData
    | FormPanelType.shipmentForm;
};

const formPanelHeader = {
    [FormPanelType.invoiceData]: {
        Component: (props: any) => <InvoiceData {...props} />,
        image: <Icon.CardPage />,
        title: 'Dane do faktury',
    },
    [FormPanelType.payment]: {
        Component: (props: any) => <PaymentType {...props} />,
        image: <Icon.Payment />,
        title: 'Sposób płatności',
    },
    [FormPanelType.realizationDate]: {
        Component: (props: any) => <RealizationDate {...props} />,
        image: null,
        title: 'Data realizacji',
    },
    [FormPanelType.recipientData]: {
        Component: (props: any) => <RecipientData {...props} />,
        image: <Icon.Invoice />,
        title: 'Dane płatnika/odbiorcy',
    },
    [FormPanelType.shipmentData]: {
        Component: (props: any) => <ShipmentData {...props} />,
        image: <Icon.Shipment />,
        title: 'Dane do wysyłki',
    },
    [FormPanelType.shipmentForm]: {
        Component: (props: any) => <ShippingForm {...props} />,
        image: <Icon.CardCar />,
        title: 'Forma wysyłki',
    },
    [FormPanelType.customerEmail]: {
        Component: (props: any) => <CustomerEmail {...props} />,
        image: null,
        title: 'E-mail klienta',
    },
    [FormPanelType.notes]: {
        Component: (props: any) => <Notes {...props} />,
        image: null,
        title: 'Uwagi',
    },
};

const FormPanel: React.FC<Props> = ({ type, ...props }) => {
    const { Component, image, title } = formPanelHeader[type];
    const { componentWrapper, formPanel, formPanelTitle, formPanelWrapper, formPanelTile } = makeFormPanelStyles();

    return (
        <Grid container spacing={DEFAULT_GRID_CONTAINER_SPACING} className={formPanelTile}>
            <Grid item xs={12} md={3} className={formPanelWrapper}>
                <Box className={formPanel}>
                    <Typography className={formPanelTitle} component="h6">
                        {title}
                    </Typography>
                    <Hidden smDown>{image}</Hidden>
                </Box>
            </Grid>
            <Grid item xs={12} md={9} >
                <Box className={componentWrapper}>
                    <Component {...props} />
                </Box>
            </Grid>
        </Grid>
    );
};

export default WithPaper({ noPadding: true })(FormPanel);
